import styled from "styled-components";
import { Color, Font, breakpoints, ColorDark } from "@/shared/Constants";

export const ContentTitleTag = styled.div`
  .tag-label {
    ${Font.sansBold};
    color: ${Color.black000};
    font-size: 25px;
    padding-bottom: 20px;
    ${breakpoints.darkMode} {
      [data-theme='dark'] & {
      color: ${ColorDark.textLight};
      }
    }
    ${breakpoints.phone} {
      font-size: 20px;
    }
  }

  .tag-container {
    border-top: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
    padding: 20px 0px 25px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    ${breakpoints.darkMode} {
      [data-theme='dark'] & {
      border-bottom: 1px solid ${ColorDark.greySeparator};
      border-top: 1px solid ${ColorDark.greySeparator};
      }
    }
    .tag-title,
    .tag-description {
      ${Font.clarinVarSub2Regular};
      color: ${Color.grey};
      ${breakpoints.darkMode} {
        [data-theme='dark'] & {
        color: ${ColorDark.textLight};
        }
      }
    }
    .tag-title {
      font-size: 36px;
      ${breakpoints.phone} {
        font-size: 26px;
      }
    }
    .tag-description {
      font-size: 21px;
      line-height: 26px;
      padding-top: 12px;
      p{
        &:not(:first-child) {
          display:none;
        }
      }
      
      p, a, strong{
        display:inline-block;
        ${Font.clarinVarSub2Regular};
        font-size: 21px;
        line-height: 30px;
      }
      strong {
        ${Font.clarinVarSub2Bold};
      }
      a{
        border-bottom: 1px solid rgb(204, 0, 27);
        transition: background-color 5s linear;
        color: ${Color.grey};
        &:hover{
          color: #000;
        }
      }
      
      ${breakpoints.phone} {
        font-size: 17px;
        line-height: 23px;
      }
    }
    .related-tags {
      display: flex;
      gap: 15px;
      flex-direction: row;
      height: 100%;
      flex-wrap: wrap;
      padding-top: 20px;
      ${breakpoints.phone} {
        margin-left:14px;
        
      }
      p.desTag {
        font-size: 15px;
        line-height: 15px;
        ${Font.sansBold};
        ${breakpoints.darkMode} {
          [data-theme='dark'] & {
          color: ${ColorDark.textLight};
          }
        }
        margin: 4px 5px 0 0;
        ${breakpoints.phone} {
          translate: -8px -1px;
        }
      }
      li{
        a{
          font-size: 15px;
          line-height: 15px;
          padding: 0px 5px 0px 2px;
          min-height: 20px;
          display: flex;
          -webkit-box-align: center;
          align-items: center;
          ${Font.sansRegular};
          color: ${Color.grey};
          ${breakpoints.darkMode} {
            [data-theme='dark'] & {
            color: ${ColorDark.textLight};
            }
          }
          :hover {
            color: ${Color.grey777};
          }
        }
        &::after {
          content: "";
          width: 3px;
          height: 3px;
          border-radius: 3px;
          background: ${Color.black000};
          display: block;
          margin-top: -10px;
          margin-left: -10px;
        }
        &:first-child{
          &::after {
            display:none;
          } 
        }
      }
    }
  
  }
`;